<div class="animated fadeIn">
  <div class="d-flex align-items-center">
    <div [hidden]="!loading" class="spinner-border text-info ml-auto" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <p-toast></p-toast>

  <div class="card">
    <p-table [value]="notifications" [tableStyle]="{ 'min-width': '60rem' }">

      <!-- ✅ CAPTION = TITRE + BOUTON -->
      <ng-template pTemplate="caption">
        <div class="flex items-center justify-between">
          <span class="text-xl font-bold">📋 Notifications programmées</span>

          <button
            pButton
            type="button"
            icon="pi pi-plus"
            label="Nouvelle notification"
            class="p-button-sm p-button-success"
            (click)="goToScheduler()"
          ></button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>Titre</th>
          <th>Description</th>
          <th>Jours</th>
          <th>Heure début</th>
          <th>Heure fin</th>
          <th>Interval (min)</th>
          <th>Status</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-notification>
        <tr>
          <td>{{ notification.title }}</td>
          <td>{{ notification.description }}</td>
          <td>{{ notification.daysOfWeek?.join(', ') }}</td>
          <td>{{ notification.startFormatted || '-'}}</td>
          <td>{{ notification.endFormatted || '-'  }}</td>
          <td>{{ notification.intervalMinutes || '-' }}</td>
          <!-- <td>
            <span
              class="status"
              [ngClass]="notification.isActive ? 'on' : 'off'"
            >
              {{ notification.isActive ? 'ON' : 'OFF' }}
            </span>
          </td> -->
          <td>
            <span
                  [ngStyle]="{
                    'background-color': notification.sendStatusLabel === 'Envoi en cours' ? '#d4f7dc' : '#f8d7da',
                    'color': notification.sendStatusLabel === 'Envoi en cours' ? '#1e7e34' : '#842029',
                    'padding': '4px 10px',
                    'border-radius': '12px',
                    'font-weight': '600',
                    'font-size': '12px',
                    'display': 'inline-block'
                  }"
            >
              {{ notification.sendStatusLabel }}
            </span>
          </td>

            <td>
    <button
      pButton
      type="button"
      icon="pi pi-trash"
      class="p-button-sm p-button-danger"
      (click)="deleteNotification(notification.id)"
    ></button>
  </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr>
          <td colspan="7">
            Total : {{ notifications?.length || 0 }} notifications
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
